import { types, actions } from './requests'
export const DELETEORGANIZATION_TYPES = {
    ...types('DELETEORGANIZATION'),
}
export const DELETEORGANIZATION_ACTIONS = {
    ...actions('DELETEORGANIZATION'),
}
